var voted_users_rtlignore_default = {
  "container": "Jjg0k",
  "webview": "I5VLt",
  "avatar_list": "rVk-p",
  "avatar": "lMA0S",
  "user_avatar": "_3eMdz",
  "modal": "t3ko2",
  "voted_users_modal": "_5-hZ9",
  "overlay": "BSi3R",
  "user_card": "LxEUc",
  "user_name": "WaOeG",
  "voted_users_modal_header": "HShGx",
  "cta": "ZsmCV",
  "close_icon": "QMkOj",
  "title": "H5an4",
  "member_list_container": "dK3ZA",
  "member_list": "u1G4j",
  "loader": "BUY3B",
  "anonymous_counter": "FHjJW",
  "spinner": "UYKG9",
  "spin": "kj9kc"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
